import { Navigate, useLocation } from 'react-router-dom';
import UserAuth from '@services/auth';
import React, { FC } from 'react';
import { initAmplitude, sendAmplitudeData } from '@utils/amplitude';
import { VISITED_SIGN_IN_PAGE } from '@constants/eventNames';

interface LocationState {
  unmatchedPathQueryParams: string;
}

const PrivateRoute: FC<{ children: React.ReactNode }> = ({ children }) => {
  const isLoggedIn = UserAuth.isAuthenticated;
  const location = useLocation() as { state: LocationState; pathname: string };
  const currentPathname = location.pathname;
  const unmatchedPath = location.state?.unmatchedPathQueryParams || '';

  const queryParams = new URLSearchParams(unmatchedPath);

  // Access individual query parameters
  const utmSource = queryParams.get('utm_source');
  const utmMedium = queryParams.get('utm_medium');
  const utmCampaign = queryParams.get('utm_campaign');
  const utmContent = queryParams.get('utm_content');

  if (!isLoggedIn) {
    UserAuth.clearTokens();
    initAmplitude();
    sendAmplitudeData(VISITED_SIGN_IN_PAGE, {
      URL: currentPathname,
      utm_source: utmSource || '',
      utm_medium: utmMedium || '',
      utm_campaign: utmCampaign || '',
      utmContent: utmContent || ''
    });

    return <Navigate to='/sign-in' state={{ from: currentPathname }} replace />;
  } else {
    return <>{children}</>;
  }
};

export default PrivateRoute;
